import React from 'react';
import { UpdateNote } from '../../../types/EducationHub';
import styles from '../../../styles/EducationHub.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';

interface ContentUpdateProps {
  update: UpdateNote;
}

const ContentUpdate: React.FC<ContentUpdateProps> = ({ update }) => {
  if (!update) return null;

  return (
    <div className={styles.updateDetails}>
      {update.features && update.features.length > 0 && (
        <div className={styles.updateSection}>
          <h4>✨ New Features ({update.features.length})</h4>
          <ul>
            {update.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
      )}

      {update.improvements && update.improvements.length > 0 && (
        <div className={styles.updateSection}>
          <h4>🚀 Improvements ({update.improvements.length})</h4>
          <ul>
            {update.improvements.map((improvement, index) => (
              <li key={index}>{improvement}</li>
            ))}
          </ul>
        </div>
      )}

      {update.bugFixes && update.bugFixes.length > 0 && (
        <div className={styles.updateSection}>
          <h4>🐛 Bug Fixes ({update.bugFixes.length})</h4>
          <ul>
            {update.bugFixes.map((fix, index) => (
              <li key={index}>{fix}</li>
            ))}
          </ul>
        </div>
      )}

      {update.knownIssues && update.knownIssues.length > 0 && (
        <div className={styles.updateSection}>
          <h4>⚠️ Known Issues ({update.knownIssues.length})</h4>
          <ul>
            {update.knownIssues.map((issue, index) => (
              <li key={index}>{issue}</li>
            ))}
          </ul>
        </div>
      )}

      {update.downloadUrl && (
        <div className={styles.updateSection}>
          <h4>💾 Download</h4>
          <a 
            href={update.downloadUrl} 
            className={`${buttonStyles.button} ${buttonStyles.primary} ${styles.downloadButton}`}
            target="_blank" 
            rel="noopener noreferrer"
          >
            Download v{update.version}
          </a>
        </div>
      )}
    </div>
  );
};

export default ContentUpdate;
